import { TemplateRef } from '@angular/core';
import {
  CellTemplateContext,
  ColumnBuilder,
  crudActions,
  DatasetTableConfig,
  TableConfigBuilder,
} from '@ui/lib/ui-kit/ui-dataset-table';
import { IntelligenceModels } from '@models/intelligence.model';

export type VariableResultCellContext = CellTemplateContext<IntelligenceModels.Variables.Variable>;

export interface CreateVariablesResultTableConfigDependencies {
  typeCellTemplate: TemplateRef<VariableResultCellContext>;
  valueCellTemplate: TemplateRef<VariableResultCellContext>;
}

/** Cmd+K mirror of the Variables page table. */
export function createVariablesResultTableConfig(
  dependencies: CreateVariablesResultTableConfigDependencies,
): DatasetTableConfig<IntelligenceModels.Variables.Variable> {
  const builder = new ColumnBuilder<IntelligenceModels.Variables.Variable>();

  return new TableConfigBuilder<IntelligenceModels.Variables.Variable>()
    .columns([
      builder
        .column('name')
        .label('VARIABLES.TABLE.NAME')
        .width('minmax(150px, 1fr)')
        .mobileVisible()
        .cardMode('label-only')
        .build(),
      builder
        .column('type')
        .label('VARIABLES.TABLE.TYPE')
        .width('minmax(70px, 0.8fr)')
        .cellTemplate(dependencies.typeCellTemplate)
        .mobileVisible()
        .cardMode('label-only')
        .build(),
      builder
        .column('value')
        .label('VARIABLES.TABLE.VALUE')
        .width('minmax(80px, 1fr)')
        .cellTemplate(dependencies.valueCellTemplate)
        .cardMode('label-only')
        .build(),
    ])
    .actions(crudActions<IntelligenceModels.Variables.Variable>())
    .trackBy('name')
    .rowHeight(52)
    .build();
}
